const { Parser } = require('json2csv');
const FileSaver = require('file-saver');
const moment = require("moment");

angular
  .module("AccountingBoxApp")
  .controller("BookkeeperUsageOverviewCtrl", function(
    $scope,
    $rootScope,
    $location,
    $filter,
    $stateParams,
    $state,
    $interval,
    $cachedResource,
    Company
  ) {
    $scope.order = {
      by: ["bankTransactionsCurrentQuarterDifference", "customerNumber"],
      reverse: false,
      filter: ""
    };
    var propsPrefix = "AB-";

    var vm = this;

    vm.loading = false;
    vm.yearChanged = function() {
      vm.refreshData();
    };
    vm.year = moment().year().toString();
    vm.quarter = moment().quarter().toString();
    console.log(vm.year, vm.quarter);
    vm.refreshData = function() {
      vm.loading = true;
      Company.usageOverview({
        year: vm.year
      }).$promise.then(function(companies) {
        vm.loading = false;
        vm.companies = companies;
        organize();
      });
    };

    const banktransactionBuckets  =  {
      0: 0,
      30: 0,
      75: 30,
      150: 75,
      250: 150,
      375: 250,
      500: 375,
      750: 500,
      1000: 750,
      1250: 1000,
      1500: 1250,
      1750: 1500,
      2000: 1750,
      2250: 2000,
      2500: 2250,
    }

    const bankTransactionOptions =  [
      0,
      30,
      75,
      150,
      250,
      375,
      500,
      750,
      1000,
      1250,
      1500,
      1750,
      2000,
      2250,
      2500,
    ]

    vm.quarterChanged = function () {
      organize();
    }

    const pricesBV = {
      0: 0,
      30: 49,
      75: 99,
      150: 129,
      250: 149,
      375: 179,
      500: 209,
      750: 269,
      1000: 329,
      1250: 389,
      1500: 449,
      1750: 509,
      2000: 569,
      2250: 629,
      2500: 689
    };

    const pricesEenmanszaak = {
        0: 0,
        30: 49,
        75: 64,
        150: 89,
        250: 119,
        375: 149,
        500: 179,
        750: 239,
        1000: 299,
        1250: 369,
        1500: 419,
        1750: 479,
        2000: 539,
        2250: 599,
        2500: 659
    }

    function organize() {
      vm.quarterName = `bankTransactionsQ${vm.quarter}Count`
      vm.filteredCompanies = (vm.companies||[]).filter(c => c.customerNumber && (!c.endDate || moment(c.endDate).isAfter(moment()))).map((c)=> {
        const bankTransactionsCurrentQuarter = c[vm.quarterName]
        const bankTransactionsCurrentQuarterDifference = c.maximumBankTransactionsPerQuarter - bankTransactionsCurrentQuarter
        const differenceAction = bankTransactionsCurrentQuarterDifference < 0 ? 'upgrade' : (bankTransactionsCurrentQuarter <= banktransactionBuckets[c.maximumBankTransactionsPerQuarter] ? 'downgrade' : '')
        const differenceColor = differenceAction === 'upgrade' ? '#fcb8b8' : (differenceAction === 'downgrade' ? '#c0f9e4' : 'white')

        const higherBucket = bankTransactionOptions.find(b => b >= bankTransactionsCurrentQuarter)
        const higherPrice = c.businessType === 'B.V.' ? pricesBV[higherBucket] : pricesEenmanszaak[higherBucket]
        const emailContent = `Beste ${c.contact.firstName},\n\n` +
          `Ik wil je informeren over een wijziging in je abonnement bij AdministratieBox.\n\n`+
          `Op dit moment heb je een abonnement met maximaal ${c.maximumBankTransactionsPerQuarter} banktransacties per kwartaal.\nDit is afgelopen kwartaal overschreden. Het aantal banktransacties is uitgekomen op ${bankTransactionsCurrentQuarter}.\n\n`+
          `We gaan je abonnement daarom aanpassen naar maximaal ${higherBucket || '___'} banktransacties per kwartaal.\n`+
          `Met ingang van ${moment().add(1, 'month').startOf('month').format('DD-MM-YYYY')} wordt je basis maandtarief € ${higherPrice},-.\n\n`+
          `Voor een overzicht van de tarieven kun je kijken op https://www.administratiebox.nl/prijzen.\n\n`+

          `Als je vragen of opmerkingen hebt over deze wijziging, neem dan contact met ons op.\n\n\n`+

          `Met vriendelijke groet,\n\n`+
          `AdministratieBox`
        const mailto = encodeURI(`mailto:${c.contact.email}?subject=Wijziging abonnement&body=${emailContent}`)
        return {
          ...c,
          startMonth: moment(c.startDate).format('MMM YYYY'),
          bankTransactionsQ1Difference: c.maximumBankTransactionsPerQuarter - c.bankTransactionsQ1Count,
          bankTransactionsQ2Difference: c.maximumBankTransactionsPerQuarter - c.bankTransactionsQ2Count,
          bankTransactionsQ3Difference: c.maximumBankTransactionsPerQuarter - c.bankTransactionsQ3Count,
          bankTransactionsQ4Difference: c.maximumBankTransactionsPerQuarter - c.bankTransactionsQ4Count,
          bankTransactionsCurrentQuarter,
          bankTransactionsCurrentQuarterDifference,
          differenceAction,
          differenceColor,
          mailto
        }
      })
    }
    vm.refreshData();
    vm.download = function() {

      const fields = [{
        label: 'Bedrijfsnaam',
        value: 'name'
      },
        {
        label: 'Inkoopfacturen',
        value: 'purchasesCount'
      },
        {
          label: 'Verkoopfacturen',
          value: 'salesCount'
        },
        {
          label: 'Memorialen',
          value: 'journalEntriesCount'
        },
        {
          label: 'Totaal',
          value: 'totalCount'
        },
        {
          label: 'Maximaal per jaar',
          value: 'maximalInvoicesSubscription'
        },
        {

          label: 'Verschil',
          value: 'difference'
        },
        {
          label: 'Abonnement bank',
          value: 'maximumBankTransactionsPerQuarter'
        },
        {
          label: 'Q1',
          value: 'bankTransactionsQ1Count'
        },
        {
          label: 'Q2',
          value: 'bankTransactionsQ2Count'
        },
        {
          label: 'Q3',
          value: 'bankTransactionsQ3Count'
        },
        {
          label: 'Q4',
          value: 'bankTransactionsQ4Count'
        },
        {
          label: 'Totaal',
          value: 'bankTransactionsCount'
        },
      ];

      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(vm.companies);
      var blob = new Blob([csv], {type: "text/csv;charset=utf-8"});
      FileSaver.saveAs(blob, 'bedrijven-overzicht-gebruik-'+vm.year);

      console.log(csv);
    }
  });
